module.exports = "{{::priorType}} ~ {{::priorDistribution}} ({{::param1}}, {{::param2}})\n";